var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-size",attrs:{"id":"app"},on:{"keydown":function($event){return _vm.Tab($event)}}},[_c('PWAPrompt'),_c('router-view'),_c('modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }